// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1G8bn","content":"styles_content__3qJWe","row":"styles_row__1HwQ1","footer":"styles_footer__3ZtVO","phraseLength":"styles_phraseLength__3I_B-"};